import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { withAgentPage } from 'hocs';
import { isLogged } from 'services/commons';
import { setLoginRedirect } from 'util/navigation';
import { PROJECT_BASENAME } from 'constants/env';

const ProtectedRoute = ({
  component: Component,
  strict = true,
  agentStaffId,
  ...rest
}) => {
  const isUserLogged = isLogged();
  const showProtectedPage = strict
    ? isUserLogged
    : isUserLogged || agentStaffId;
  return (
    <Route
      {...rest}
      render={(props) => {
        const { location } = props;
        const pathname = location.pathname.replace('/', '')

        // eslint-disable-next-line no-unused-expressions
        !showProtectedPage &&
          setLoginRedirect(
            `${pathname}${location.search}`,
            true,
            isUserLogged,
            false
          );

        return showProtectedPage ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={`/login?redirect=${window.location.origin}${PROJECT_BASENAME}${pathname}${location.search}`}
          />
        );
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  component: PropTypes.any.isRequired,
  strict: PropTypes.bool
};

export default withAgentPage()(ProtectedRoute);
